import { Stack, Typography } from '@mui/material';
import {
  resourceIconMap,
  type IconName,
} from '@/constants/resources/resources-icons';

interface MetaItemProps {
  children: React.ReactNode;
  icon: IconName;
}

export const MetaItem = ({ children, icon }: MetaItemProps) => {
  const Icon = resourceIconMap[icon] || null;

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.5}
      color="neutral.500"
    >
      {Icon && <Icon fontSize="small" />}
      <Typography variant="body2">{children}</Typography>
    </Stack>
  );
};
